// extracted by mini-css-extract-plugin
export var content = "_5v-3";
export var list = "_5v-4";
export var settingsContent = "_5v-7";
export var settingsPanel = "_5v-8";
export var state = "_5v-6";
export var triggerBadge = "_5v-2";
export var triggerButton = "_5v-1";
export var triggerShell = "_5v-0";
export var unreadDot = "_5v-5";